var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link--q",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("NTT東日本ビジネスIDとは")])}
var staticRenderFns = []

export { render, staticRenderFns }